import { Link } from "react-router-dom";
import { Compass, Home, TicketPercent, Tags, Sparkles } from "lucide-react";
import { MaskedLine } from "../components/Motion";
import { Seo } from "../components/Seo";

const LINKS = [
    { to: "/", label: "Home", icon: Home, testId: "nf-home" },
    { to: "/offers", label: "Offers", icon: TicketPercent, testId: "nf-offers" },
    { to: "/coupons", label: "Coupons", icon: Tags, testId: "nf-coupons" },
    { to: "/search", label: "AI Search", icon: Sparkles, testId: "nf-search" },
];

const NotFoundPage = () => (
    <>
        <Seo
            title="Page not found — SahiKhoj"
            description="The page you are looking for does not exist on SahiKhoj."
            path="/404"
            noindex
        />
        <section className="hero-glow flex min-h-[85vh] items-center bg-ink pt-24 text-cream" data-testid="not-found-page">
            <div className="mx-auto max-w-3xl px-6 py-20 text-center sm:px-8">
                <p className="flex items-center justify-center gap-3 font-mono text-xs uppercase tracking-[0.24em] text-mist">
                    <Compass className="h-4 w-4 text-saffron" />
                    Galat khoj
                </p>
                <h1 className="mt-6 font-display text-7xl font-semibold tracking-tighter sm:text-8xl">
                    <MaskedLine delay={0.15}>
                        4<span className="text-saffron">0</span>4
                    </MaskedLine>
                </h1>
                <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-mist">
                    This page doesn't exist — but your sahi daam is still out there.
                    Try one of these instead:
                </p>
                <div className="mt-10 flex flex-wrap justify-center gap-3">
                    {LINKS.map(({ to, label, icon: Icon, testId }) => (
                        <Link
                            key={to}
                            to={to}
                            data-testid={testId}
                            className="inline-flex items-center gap-2 rounded-full border border-cream/20 px-6 py-3 text-sm font-medium text-cream transition-colors hover:border-saffron hover:text-saffron"
                        >
                            <Icon className="h-4 w-4" />
                            {label}
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    </>
);

export default NotFoundPage;
